module.exports = __webpack_public_path__ + "b844439f893b169cf2c1415327ac008f.MP3";